"use strict";

exports.__esModule = true;
exports["default"] = exports.ApolloProvider = exports.ApolloContext = void 0;
var _reactApollo = require("react-apollo");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ApolloContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.ApolloContext = ApolloContext;
var ApolloProvider = function ApolloProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloConsumer, null, function (client) {
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloProvider, {
      client: client
    }, /*#__PURE__*/_react["default"].createElement(ApolloContext.Provider, {
      value: {
        client: client
      }
    }, children));
  });
};
exports.ApolloProvider = ApolloProvider;
var useApollo = function useApollo() {
  return (0, _react.useContext)(ApolloContext);
};
var _default = useApollo;
exports["default"] = _default;